export default __webpack_public_path__ + "static/media/de337154c803534603a7d5f00b4f983c1600873309627.1fbefda2.webp";